import { RFPType } from "./procurementTypes";

export const RFPURLS: Record<RFPType, string> = {
  DDQ: "ddq",
  ESRS: "esrs",
  Passport: "passport",
  QTP: "qtp",
  RFI: "rfi",
  RFP: "rfp",
  Regulation: "questionnaire",
};
